<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-receipt-modal')"><i class="las la-times"></i></button>
        </template>
        <template v-slot:body>
            <div id="myDivToPrint" style="padding: 20px 40px;">
                <div class="text-center margin-bottom-40">
                    <h4>{{$t('receipt.title')}}</h4>
                    <span class="text-muted">{{$t('receipt.subtitle')}} #{{order.id}}</span>
                </div>
                <div class="margin-bottom-40">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td style="border: 0;">
                                    <b>{{$t('receipt.amount_paid')}}</b>
                                    <br> <span v-if="order.payment_mode === PAYMENT_MODE.CREDIT_CARD">{{getCurrencySymbolFromString(order.price_gross_currency)}}{{order.price_gross}}</span>
                                        <span v-else>{{getCurrencySymbolFromString(order.price_currency)}}{{order.price}}</span>
                                </td>
                                <td style="border: 0;">
                                    <b>{{$t('receipt.date')}}</b>
                                    <br>{{getDataString(order.created_date)}}
                                </td>
                                <td style="border: 0;">
                                    <b>{{$t('receipt.payment_method')}}</b>
                                    <div v-if="order.payment_mode === PAYMENT_MODE.CREDIT_CARD && order.stripe_payment_intent">
                                        <img :src="'https://stripe-images.s3.amazonaws.com/emails/receipt_assets/card/' + order.stripe_payment_intent.charges.data[0].payment_method_details.card.brand + '-dark@2x.png'" style="height: 16px;"> - {{order.stripe_payment_intent.charges.data[0].payment_method_details.card.last4}}
                                    </div>
                                    <div v-else>
                                        {{getStringPaymentMode(order.payment_mode)}}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="margin-bottom-40">
                    <h4>{{$t('receipt.summary')}}</h4>
                    <div class="panel panel-default" style="background-color: #f7f7f7;border: 0;">
                        <div class="panel-body">
                            <table class="table">
                                <tbody>
                                    <tr v-for="order_item in order.items" v-bind:key="order_item.id">
                                        <td style="border: 0;">
                                            {{order_item.title}} <i>({{getStringOrderItemType(order_item.type)}})</i>
                                        </td>
                                        <td class="text-right" style="border: 0;">
                                            {{getCurrencySymbolFromString(order.price_currency)}}{{order.price}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{$t('receipt.service_fee')}}
                                        </td>
                                        <td class="text-right">
                                            <span v-if="order.payment_mode === PAYMENT_MODE.CREDIT_CARD">
                                                {{getCurrencySymbolFromString(order.price_gross_currency)}}{{(parseFloat(order.price_gross) - parseFloat(order.price)).toFixed(2)}}
                                            </span>
                                            <span v-else>
                                                {{getCurrencySymbolFromString(order.price_currency)}}0.00
                                            </span>
                                        </td>
                                    </tr>
                                    <tr class="bold">
                                        <td>
                                            {{$t('receipt.amount_charged')}}
                                        </td>
                                        <td class="text-right">
                                            <span v-if="order.payment_mode === PAYMENT_MODE.CREDIT_CARD">{{getCurrencySymbolFromString(order.price_gross_currency)}}{{order.price_gross}}</span>
                                            <span v-else>{{getCurrencySymbolFromString(order.price_currency)}}{{order.price}}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <hr>
                {{$t('receipt.info_1')}} <a :href="'mailto:' + order.company.email">{{order.company.email}}</a> {{$t('receipt.info_2')}} <a :href="'tel:' + order.company.phone_number" >{{order.company.phone_number}}</a>.
                <hr>
                <span class="small text-muted">{{$t('receipt.footer_note')}}</span>
            </div>
        </template>

        <template v-slot:footer>
            <div class="row">
                <div class="col-xs-6">
                    <a class="btn btn-default btn-block" href="#">
                        <i class="las la-envelope"></i>
                        {{$t('receipt.button_email')}}
                    </a>
                </div>
                <div class="col-xs-6">
                    <a class="btn btn-default btn-block" href="#">
                        <i class="las la-print"></i>
                        {{$t('common.print')}}
                    </a>
                </div>
            </div>
        </template>
    </ModalContainer>
</template>

<script>
    import ModalContainer from "./ModalContainer";
    import {Utils} from "../../common/utils";
    import {PAYMENT_MODE} from "../../common/constants";
    export default {
        name: "ReceiptModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            order: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                PAYMENT_MODE: PAYMENT_MODE,
                loading: false,
                errorMessage: ""
            }
        },
        components: {ModalContainer},
        methods: {
            getDataString(date) {
                return Utils.getDateStringFromISO(date)
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency);
            },
            getStringPaymentMode(payment_mode) {
                return Utils.getStringPaymentMode(payment_mode)
            },
            getStringOrderItemType(type) {
                return Utils.getStringOrderItemType(type);
            }
        }
    };
</script>
